import { SectionLabel, type SectionLabelProps } from "@components/SectionLabel";

export type { SectionLabelProps as StudioSectionLabelProps };

export const StudioSectionLabel = (props: SectionLabelProps) => <SectionLabel size="md" {...props} />;
